import Vue from 'vue'
import VueRouter from 'vue-router'
import GLOBAL from '@/components/customInfo/Global.vue'
// import LoginPage from '@/pages/login/LoginPage.vue'
// import LogonPage from '@/pages/login/LogonPage.vue'
// import MainPage from '@/pages/home/MainPage.vue'
// import ListPage from '@/components/page/ListPage.vue'
// import AddOrUpPage from '@/components/page/AddOrUpPage.vue'
// import Question from '@/components/exam/Question.vue'
// import ExamPaper from '@/components/exam/ExamPaperSet.vue'
// import DoQuestion from '@/components/exam/DoQuestion.vue'
// import DoExamPaper from '@/components/exam/DoExamPaper.vue'
// import KnowledgeTree from '@/components/exam/KnowledgeTree.vue'
// import ShopHome from '@/components/shopping/ShopHome.vue'
// import GoodsList from '@/components/shopping/GoodsList.vue'
// import GoodsDetail from '@/components/shopping/GoodsDetail.vue'
// import ShopCart from '@/components/shopping/ShopCart.vue'
// import MyOrder from '@/components/shopping/MyOrder.vue'
// import PayQrCode from '@/components/shopping/PayQrCode.vue'
// import ShopOutLine from '@/components/shopping/ShopOutLine.vue'
// import ppt from '@/components/ppt/ppt.vue'
// import Problem from '@/components/problemAnwer/Problem.vue'
// import ProblemShow from '@/components/problemAnwer/ProblemShow.vue'
// import Report from '@/components/page/Report.vue'
// import Schedule from '@/components/page/Schedule.vue'
// import PageShowSet from '@/components/page/pageSet/PageShowSet.vue'
// import NotFound from '@/components/error/NotFound.vue'
// // 托福模考 分析页面
// import AnalysisReport from '@/components/exam/AnalysisReport.vue'
// // 商城的首页
// import MailHome from '@/pages/newMail/mail_home.vue'
// // 新列表首页
// import look from '@/pages/pageShow/look/look.vue'
// // 添加修改查看页面
// import new_list from '@/pages/pageShow/new_list/new_list.vue'
// // 新版的 路由中间页面 跳转查看或者列表页面
// import route_middel from '@/pages/pageShow/route_middel/route_middel.vue'

Vue.use(VueRouter)

export default new VueRouter({
    mode:"history",
    base:'/'+ GLOBAL.vueProjectName + '/', //qcbl_edus_auto  vue_kw_plat test_kw_plat  online   hdgj_pdf
    linkActiveClass:"active",
    linkExactActiveClass:"currentActive",
    routes: [
        {
            path: '/loginPage',
            name: 'LoginPage',
            component: resolve => require(['@/pages/login/LoginPage'], resolve)
        },
        {
            path: '/loginPage/:domain_name',
            name: 'LoginPage',
            component: resolve => require(['@/pages/login/LoginPage'], resolve)
        },
        {
            path: '/logonPage',
            name: 'LogonPage',
            component: resolve => require(['@/pages/login/LogonPage'], resolve),
        },
        // 首页的路由
        {
            path: '/mainPage',
            name: 'MainPage',
            component: resolve => require(['@/pages/home/MainPage'], resolve),
        },
        // 列表的路由
        // {
        //     path: '/listPage',
        //     name: 'ListPage',
        //     component: resolve => require(['@/components/page/ListPage'], resolve),
        // },
        // 添加修改查看页面的路由
        // {
        //     path: '/addOrUpPage',
        //     name: 'AddOrUpPage',
        //     component: resolve => require(['@/components/page/AddOrUpPage'], resolve),
        // },
        // 试题的路由
        {
            path: '/vueQuestion/:initShowType/:initQuestionId',
            name: 'Question',
            component: resolve => require(['@/components/exam/Question'], resolve),
        },
        //试卷的路由
        {
            path: '/vueExamPaper',
            name: 'ExamPaper',
            component: resolve => require(['@/components/exam/ExamPaperSet'], resolve),
        },
        {
            path: '/vueExamPaper/:examPaperId',
            name: 'ExamPaper',
            component: resolve => require(['@/components/exam/ExamPaperSet'], resolve),
        },
        //学员试题的路由
        {
            path: '/vueDoQuestion/:initProId/:initShowType/:initStuId/:initQuestionId/:initStudentQuestionId',
            name: 'DoQuestion',
            component: resolve => require(['@/components/exam/DoQuestion'], resolve),
        },
        //学员试卷的路由
        {
            path: '/vueDoExamPaper/:initProId/:initShowType/:initStuId/:initExamPaperId/:initStudentExamPaperId',
            name: 'DoExamPaper',
            component: resolve => require(['@/components/exam/DoExamPaper'], resolve),
        },
        {
            path: '/vueDoExamPaper',
            name: 'vueDoExamPaper',
            component: resolve => require(['@/components/exam/DoExamPaper'], resolve),
        },
        //模考试卷的路由
        {
            path: '/vueDoTf/:initProId/:initShowType/:initStuId/:initExamPaperId/:initStudentExamPaperId',
            name: 'DoExamPaper',
            component: resolve => require(['@/components/exam/DoExamPaperToefl'], resolve),
        },
        {
            path: '/vueDoTf',
            name: 'vueDoExamPaper',
            component: resolve => require(['@/components/exam/DoExamPaperToefl'], resolve),
        },

        //知识树的路由
        // {
        //     path: '/KnowledgeTree',
        //     name: 'KnowledgeTree',
        //     component: resolve => require(['@/components/exam/KnowledgeTree'], resolve),
        // },
        //VUE商城首页
        // {
        //     path: '/shopHome',
        //     name: 'ShopHome',
        //     component: resolve => require(['@/components/shopping/ShopHome'], resolve),
        // },
        //VUE商城的课程列表的具体日期的课表页面
        // {
        //     path: '/goodsList',
        //     name: 'GoodsList',
        //     component: resolve => require(['@/components/shopping/GoodsList'], resolve),
        // },
        //VUE商城的课程详情页面
        // {
        //     path: '/goodsDetail',
        //     name: 'GoodsDetail',
        //     component: resolve => require(['@/components/shopping/GoodsDetail'], resolve),
        // },
        //VUE商城的购物车页面
        // {
        //     path: '/shopCart',
        //     name: 'ShopCart',
        //     component: resolve => require(['@/components/shopping/ShopCart'], resolve),
        // },
        //VUE商城的我的订单页面
        // {
        //     path: '/myOrder',
        //     name: 'MyOrder',
        //     component: resolve => require(['@/components/shopping/MyOrder'], resolve),
        // },
        //VUE商城的微信支付二维码页面
        // {
        //     path: '/payQrCode',
        //     name: 'PayQrCode',
        //     component: resolve => require(['@/components/shopping/PayQrCode'], resolve),
        // },
        // {
        //     path: '/shopOutLine',
        //     name: 'ShopOutLine',
        //     component: resolve => require(['@/components/shopping/ShopOutLine'], resolve),
        // },
        //VUE：kw_ppt功能
        // {
        //     path: '/ppt',
        //     name: 'ppt',
        //     component: resolve => require(['@/components/ppt/ppt'], resolve),
        // },
        //VUE：报表功能
        {
            path: '/report',
            name: 'Report',
            component: resolve => require(['@/components/page/Report'], resolve),
        },
        //问答功能 提问的路由
        // {
        //     path: '/problem',
        //     name: 'Problem',
        //     component: resolve => require(['@/components/problemAnwer/Problem'], resolve),
        // },
        //问答功能 查看问答页面
        // {
        //     path: '/problemShow',
        //     name: 'ProblemShow',
        //     component: resolve => require(['@/components/problemAnwer/ProblemShow'], resolve),
        // },
        //课表功能
        // {
        //     path: '/schedule',
        //     name: 'Schedule',
        //     component: resolve => require(['@/components/page/Schedule'], resolve),
        // },
        //页面设置
        {
            path: '/pageShowSet',
            name: 'PageShowSet',
            component: resolve => require(['@/components/page/pageSet/PageShowSet'], resolve),
        },
        //报表页面设置
        {
            path: '/reportShowSet',
            name: 'ReportShowSet',
            component: resolve => require(['@/components/page/pageSet/ReportShowSet'], resolve),
        },
        //对象页面设置
        {
            path: '/mongoObjectSet',
            name: 'MongoObjectSet',
            component: resolve => require(['@/components/page/pageSet/MongoObjectSet'], resolve),
        },
        //触发器页面设置
        {
            path: '/TriggerSet',
            name: 'TriggerSet',
            component: resolve => require(['@/components/page/objectSet/TriggerSet'], resolve),
        },
        //触发器Sql拼接页面
        {
            path: '/autoTriggerSql',
            name: 'autoTriggerSql',
            component: resolve => require(['@/components/page/objectSet/AutoTriggerSql'], resolve),
        },
        // 托福模考的分析页面
        {
            path: '/analysisReport',
            name: 'AnalysisReport',
            component: resolve => require(['@/components/exam/AnalysisReport'], resolve),
        },
        // 新版的商城首页 
        {
            path: '/mailHome',
            name: 'MailHome',
            component: resolve => require(['@/pages/newMail/mail_home'], resolve),
        },
        // 新版的商城首页 
        {
            path: '/mailHome/:domain_name',
            name: 'MailHome',
            component: resolve => require(['@/pages/newMail/mail_home'], resolve),
        },
        // 新版的查看页面 
        {
            path: '/look',
            name: 'look',
            meta: { isShare:true },
            component: resolve => require(['@/pages/pageShow/look/look'], resolve),
        },
        // 新版的查看页面 
        {
            path: '/look/:domain_name',
            name: 'look',
            meta: { isShare:true },
            component: resolve => require(['@/pages/pageShow/look/look'], resolve),
        },
        // 新版的列表页面
        {
            path: '/new_list',
            name: 'new_list',
            component: resolve => require(['@/pages/pageShow/new_list/new_list'], resolve),
        },
        // 新版的列表页面
        {
            path: '/new_list/:domain_name',
            name: 'new_list',
            component: resolve => require(['@/pages/pageShow/new_list/new_list'], resolve),
        },
        // 新版的中间页面
        {
            path: '/route_middel',
            name: 'route_middel',
            component: resolve => require(['@/pages/pageShow/route_middel/route_middel'], resolve),
        },
		
		// 直播间txy
		{
		    path: '/liveIndex',
		    name: 'liveIndex',
		    component: resolve => require(['@/components/liveTxy/liveIndex'], resolve),
		},
	
        // 直播间
        {
            path: '/liveRoom',
            name: 'liveRoom',
            component: resolve => require(['@/components/live/LiveRoom'], resolve),
        },
        // 预览组件页面
		{
		    path: '/kwFilePreview',
		    name: 'kwFilePreview',
		    component: resolve => require(['@/components/kw/kw_file_preview'], resolve),
		},
        {
            path: '*',
            name: 'NotFound',
            component: resolve => require(['@/components/error/NotFound'], resolve),
        },
        {
            path:"/",
            // 重定向
            redirect:"/mailHome",
            component: resolve => require(['@/pages/login/LogonPage'], resolve),
        }
		
    ]
})
